
import { CalendarIcon } from "lib-core"

export default CalendarIcon
